<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Research Agenda</h4>
              <p class="category">*Ever Evolving*</p>
            </div>
            <div class="card-content">
              <p>I am a Human-Computer Interaction researcher focusing on Computational Creativity.  Broadly I am interested in helping users explore the possibilities of interactions with co-creative agents.  I explore this concept through research in both co-creative agents and explainability.  You can find some of my papers below if you want to learn more about my research.</p>
            </div>
          </div>
        </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="70"
                           title="A Case-Based Reasoning Approach to Plugin Parameter Selection in Vocal Audio Production"
                           description="ICCBR 2022"
                           color="orange"
                           link="https://link.springer.com/chapter/10.1007/978-3-031-14923-8_23">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="70"
                           title="Understanding the Technological Practices and Needs of Music Therapists"
                           description="CSCW 2021"
                           color="blue"
                           link="https://d1wqtxts1xzle7.cloudfront.net/67287758/3449107-libre.pdf?1620709624=&response-content-disposition=inline%3B+filename%3DUnderstanding_the_technological_practice.pdf&Expires=1681685912&Signature=MxgcMeTA2BBEneREsF47MYi50JT7j7Q5tf1ljJ1W602brkEo4GLjYLlsQLcKMtnC9iSMjP11zHbG8z5YkdGQW4nHqEG0g5Vv8kxl-k-uovRpoIVWrcJZl7LAAhAtPJSEA3u5cAJa8Jf5TVnHfgLwAsFa9SgSW1taglHdrlYGQk3usyNpgbpjjltuRCRTKMwRBcsN5df6GmF7ySWSfN7GA~ODvxx79Ojp-UuSUhJSl4GN-1MzyHrhSblGjUHpCf9ZtW8WU4VvJPJFvj~kYqM3A5NX8dXmqwSUoaEYYoczkiBXNaWT1hcE29NPwC~sH2FuOldq1YbKFCXrx-~7hqMW4A__&Key-Pair-Id=APKAJLOHF5GGSLRBV4ZA">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="70"
                           title="The Three E’s of Explainability in Collaborative Computational Co-Creativity: Emotionality, Effectiveness, and Explicitness"
                           description="ICCBR DC 2022"
                           color="purple"
                           link="https://iccbr2022.loria.fr/files/2022/09/ICCBR_DC_Preliminary_Proceedings.pdf#page=4">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="70"
                           title="Quantitatively Assessing Explainability in Collaborative Computational Co-Creativity"
                           description="HCAI @ NeurIPS 2022"
                           color="green"
                           link="https://hcai-at-neurips.github.io/site/program.html">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="70"
                           title="Creativity Support for Novice and Sensory Impaired Users in DAWs"
                           description="Laboratory for Quantitative Experience Design"
                           color="orange"
                           link="https://1drv.ms/b/s!AuiQBsNu381rg8BvFQtWtQcfjPzfbQ?e=q00SrV">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="34"
                           title="Survey of mHealth Interventions for Serious Vision Impairments"
                           description="University of Virginia"
                           color="blue"
                           link="https://1drv.ms/b/s!AuiQBsNu381rg8BwiqlZuQ7j2nvOUA?e=SkfBDQ">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="62"
                           title="VR Cycling Comparison Study"
                           description="ORCL Lab"
                           color="purple"
                           link="https://1drv.ms/b/s!AuiQBsNu381rg8ByeSAvTFV8h0teeA?e=ncW7Q9">
        </circle-chart-card>
      </div>

      <div class="col-lg-3 col-md-6">
        <circle-chart-card :percentage="10"
                           title="The Effect of Presence on the Influence of Virtual Characters"
                           description="University of Utah"
                           color="green"
                           link="https://1drv.ms/b/s!AuiQBsNu381rg8Bx0hhcNfCdGV48Lg?e=3GtpTI">
        </circle-chart-card>
      </div>

    </div>
  </div>
</template>

<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'

  const WorldMap = () => ({
    component: import('./Maps/WorldMap.vue'),
    loading: Loading,
    delay: 200
  })

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      WorldMap
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        statsCards: [
          {
            type: 'warning',
            icon: 'ti-server',
            title: 'Capacity',
            value: '105GB',
            footerText: 'Updated now',
            footerIcon: 'ti-reload'
          },
          {
            type: 'success',
            icon: 'ti-wallet',
            title: 'Revenue',
            value: '$1,345',
            footerText: 'Last day',
            footerIcon: 'ti-calendar'
          },
          {
            type: 'danger',
            icon: 'ti-pulse',
            title: 'Errors',
            value: '23',
            footerText: 'In the last hour',
            footerIcon: 'ti-timer'
          },
          {
            type: 'info',
            icon: 'ti-twitter-alt',
            title: 'Followers',
            value: '+45',
            footerText: 'Updated now',
            footerIcon: 'ti-reload'
          }
        ],
        earningsChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
            series: [
              [230, 340, 400, 300, 570, 500, 800]
            ]
          },
          options: {
            showPoint: false,
            lineSmooth: true,
            height: '210px',
            axisX: {
              showGrid: false,
              showLabel: true
            },
            axisY: {
              offset: 40,
              showGrid: false
            },
            low: 0,
            high: 'auto',
            classNames: {
              line: 'ct-line ct-green'
            }
          }
        }

      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Research.vue